import { useFormApi } from "informedv4";
import * as React from "react";
import { MediaSerialInput } from '../../../../misc/components/cough/MediaSerialInput';

interface EnterMediaSerialForm {
    MediaSerial: string;
}

export interface EnterMediaSerialProps {
    currentMediaSerial: string;
    onNext: (value: string) => void;
}

export const EnterMediaSerial = ({ currentMediaSerial, onNext }: EnterMediaSerialProps) => {
    const formApi = useFormApi();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getFormState();

        if (state.invalid)
            return;

        onNext(state.values.MediaSerial as string);
    }

    return (
        <>           
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                        </p>
                        <div className="form-group">
                            <label>Current Card Serial Number</label>&nbsp;
                            <MediaSerialInput name="OriginalMediaSerial" id="OriginalMediaSerial" field="OriginalMediaSerial" staticPrefix="FF" value={currentMediaSerial} disabled />
                                
                        </div>
                        <div className="form-group">
                            <label>New Card Serial Number</label>&nbsp;
                            <MediaSerialInput name="MediaSerial" id="MediaSerial" field="MediaSerial" staticPrefix="FF" value={currentMediaSerial} />
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="submit" onClick={() => onSubmit()}>Next</button>
            </div>
        </>
    );
}
